// extracted by mini-css-extract-plugin
module.exports = {"bar":"RoutinesFilterBar_legacy_bar__Rm3fs","chip":"RoutinesFilterBar_legacy_chip__CjqvE"};